import z from '@/lib/zod';
import { commonSearchSchema } from './commonSearchSchema';
import { optionalSearchString } from './search-param-schemas';
import { CONTRACT_FORM_MODES } from '@/pages/contracts/lib/contract-routes';

/** Filtri della lista contratti: la stessa pagina di `/admin` e `/referrer`. */
export const contractsSearchSchema = commonSearchSchema.extend({
  /** Tab della fase della pratica (`CONTRACT_TABS`). */
  subTab: optionalSearchString(),
  status: optionalSearchString(),
  /**
   * Link di prima alla variazione da una richiesta cliente: l'indice lo
   * gira alla rotta `new` (`buildLegacyAmendmentRedirect`). Da rimuovere
   * dopo il 2026-12-31.
   */
  commercialRequestId: optionalSearchString(),
  parentContractId: optionalSearchString(),
});

export type ContractsSearch = z.output<typeof contractsSearchSchema>;

/**
 * Apertura del form di creazione: che cosa si crea e da quale pratica.
 * Un valore scritto a mano diventa un contratto nuovo, non una rotta rotta.
 */
export const contractFormSearchSchema = z.object({
  mode: z.enum(CONTRACT_FORM_MODES).optional().catch(undefined),
  sourceId: optionalSearchString(),
  commercialRequestId: optionalSearchString(),
  /**
   * Variazione dai rinnovi sui piani ritirati: il piano del listino 2026-10
   * da preselezionare e i suoi add-on (codici separati da virgola).
   */
  successorPlan: optionalSearchString(),
  successorAddons: optionalSearchString(),
});
